/**
 * to navigate through application routes use
 * @example: app.navigate('start', {optional} options);
 */
import app from 'app';
import Marionette from 'backbone.marionette';

app.namespace.Controller.StartPageController = Marionette.Object.extend({
  initialize: function () {},

  getUserStatus: function () {
    const promise = $.Deferred();
    const url = app.apiUrl('/api/v1/users/me/status');
    $.ajax({
      url: url,
      type: 'GET',
      error: $.proxy(function () {}, this),
      success: $.proxy(function (response) {
        promise.resolve(response.status);
      }, this),
    });
    return promise;
  },

  resendMail: function () {
    const promise = $.Deferred();
    const url = app.apiUrl(
      '/api/v1/verifications?email=' +
        encodeURIComponent(app.rootStore.state.user['userId'])
    );
    $.ajax({
      url: url,
      type: 'POST',
      error: $.proxy(function () {}, this),
      success: $.proxy(function (response) {
        console.log('response', response);
        promise.resolve(response);
      }, this),
    });
    return promise;
  },
});
